import React, {FC, useEffect, useState} from "react";
import {Avatar, Box, Chip, Dialog, IconButton, Tooltip, Typography} from "@mui/material";
import {useMainContext} from "../../../../../../contexts/MainContext";
import {GridColDef} from "@mui/x-data-grid";
import { CheckCircleOutline, Delete, ListAlt, Pageview } from "@mui/icons-material";
import currencyFormatter from "../../../../../../utils/currencyFormatter";
import _ from "lodash";
import {DataGridPro, GridToolbar} from "@mui/x-data-grid-pro";
import AvatarGroup from "@mui/material/AvatarGroup";
import {useNavigate} from "react-router-dom";
import Goal from "../../../../../../cog/keystone/goals/goal/Goal";
import {KeystoneAccessResponse} from "../../../../../../cog/adminManagement/Store";
import {AdminStore} from "../../../../../../cog/adminManagement";
import ConfirmDialogOpps from "./ConfirmDialogOpps";
import {useParams} from "react-router";

interface ContributionsDataGridProps {
    contributionData: {};
    setGoal: (goal: (prev) => Goal) => void;
    goal: Goal;
    update?: () => void
}

let dialogBody = () => {
    return (
        <div>
        </div>
    )
};
const ContributionsDataGrid: FC<ContributionsDataGridProps> = ({contributionData, setGoal, goal,update}) => {
    let {goalId, org, campaignId} = useParams();
    const mainCtx = useMainContext()

    const [dialogOpen, setDialogOpen] = useState(false);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    let columns: GridColDef[] = []
    let rows = []
    let navigate = useNavigate()

    const checkAccess = async (): Promise<KeystoneAccessResponse> => {
        try {
            return AdminStore.CheckKeystoneAccess(
                {
                    user_id: mainCtx.user.id,
                    org_id: mainCtx.activeOrganization.id
                }
            )
        } catch (e) {
            console.error(`${e}`);
        }
    }

    const handleDialogClose = () => {
        setDialogOpen(false);
        update()
    };

    const handleRemoveOpp = async (oppid) => {

        dialogBody = () => {
            return (
                <ConfirmDialogOpps handleDialogClose={handleDialogClose}
                                   loadingMethod={setLoading}
                                   admin={isAdmin}
                                   goalID={goalId}
                                   clientName={mainCtx.activeOrganization.name}
                                   oppID={oppid}
                                   goal={goal}
                                   setGoal={setGoal}
                                   type={"Remove"}/>
            )
                ;
        }
        setDialogOpen(true);
    }

    const processUserForDisplay = (id) => {
        if (mainCtx.members != null) {
            return mainCtx.members.find((obj) => {
                return obj.id === id;
            })
        }
    };

    if (Object.keys(contributionData).length === 0) {
        columns = [{"field": "NoData", "headerName": "NO DATA TO DISPLAY", "width": 400}]
    } else {
        columns = [
            {field: 'Product', headerName: 'Name', minWidth: 200, flex: 1},
            {field: 'Store', headerName: 'Store', minWidth: 200, flex: 1},
            {field: 'Opportunity_Type', headerName: 'Opportunity Type', minWidth: 200, flex: 1},
            {
                field: 'Value', headerName: 'Opportunity Value', minWidth: 200, flex: 1, renderCell: (params) => {
                    return currencyFormatter(mainCtx.activeOrganization.name, params.value)
                }
            },
            {
                field: 'Status', headerName: 'Status', minWidth: 200, flex: 1, renderCell: (params) => {
                    if (params.value == 'Resolved') {
                        return <Chip icon={<CheckCircleOutline/>}
                                     label="Resolved"
                                     color="success"/>
                    } else {
                        return <Chip icon={<ListAlt/>}
                                     label="Pending"
                                     color="error"/>
                    }
                }
            },
            {
                field: 'assigned_to', headerName: 'Users', minWidth: 200, flex: 1, renderCell: (cellValue) => {
                    let userDetails;
                    let userIDs = []
                    if (cellValue.value && cellValue.value.length > 0) {
                        userIDs = JSON.parse(cellValue.value)
                    }
                    return <Box sx={{display: 'flex', flexDirection: 'row'}}><AvatarGroup max={4}>
                        {(userIDs.length > 0) ? userIDs.map((user) =>
                                (userDetails = processUserForDisplay(user)) ?
                                    <Tooltip title={userDetails.displayName}
                                             key={userDetails.id}><Avatar
                                        src={userDetails.avatar}/></Tooltip> : null) :
                            <Typography></Typography>}
                    </AvatarGroup></Box>
                }
            },
            {
                field: "action",
                headerName: "Actions",
                sortable: false,
                flex: 0.3,
                resizable: false,
                headerAlign: 'center',
                renderCell: (params) => {

                    const handleRemoveOppTemp = () => {
                        handleRemoveOpp(params.row.id)
                    }

                    const handleNavigate = () => {
                        navigate('/app/' + mainCtx.activeOrganization.slug + '/opportunity/' + params.row.id)
                    }

                    return (
                        <Box>
                            <Tooltip title={"View Opportunity"}>
                                <IconButton aria-label="view"
                                            onClick={handleNavigate}
                                            sx={{
                                                color : (theme) => (theme.palette.mode === 'dark' ? "#ffffff" : '#6b778c'),
                                            }}>
                                    <Pageview/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={"Remove Opportunity"}>
                                <IconButton aria-label="delete"
                                            onClick={handleRemoveOppTemp}
                                            sx={{
                                                color : (theme) => (theme.palette.mode === 'dark' ? "#ffffff" : '#6b778c'),
                                            }}>
                                    <Delete/>
                                </IconButton>
                            </Tooltip>
                        </Box>
                    );
                }
            },
        ]
    }

    if (typeof contributionData === 'undefined' || Object.keys(contributionData).length === 0) {
        rows = [{id: 0, NoData: "Query returned no results"}]
    } else {
        _.range(contributionData[Object.keys(contributionData)[0]].length).map((idx) => {
            let row = {}
            row['id'] = contributionData["Opportunity_Id"][idx]
            Object.keys(contributionData).map((k) => {
                row[k] = contributionData[k][idx]
            })
            rows.push(row)
        })
    }

    useEffect(() => {
        checkAccess()
            .then((r) => {
                if (r && r.admin_permission && r.user_permission) {
                    setIsAdmin(true)
                }
            })
    }, [])

    return (<Box sx={{height: 500, width: '100%'}}>
        <DataGridPro
            columns={columns}
            rows={rows}
            pageSize={5}
            rowsPerPageOptions={[5]}
            pagination={true}
            components={{
                Toolbar: GridToolbar
            }}
            sx={{mb: 2}}
        />
        <Dialog
            //disableEnforceFocus required to open chat if Dialog opened first
            disableEnforceFocus
            open={dialogOpen}
            onClose={handleDialogClose}
            aria-labelledby="confirm-dialog"
            fullWidth
            maxWidth="md"
        >
            {dialogBody()}
        </Dialog>
    </Box>)
}

export default ContributionsDataGrid;